import React, { PropsWithChildren } from 'react';
import TouchableHighlight from './TouchableHighlight';
import TouchableOpacity from './TouchableOpacity';
import TouchableScale from './TouchableScale';

export default function Touchable(
  props: PropsWithChildren<{
    onClick?: (e: React.MouseEvent) => void;
    onTouch?: (e: React.MouseEvent) => void;
  }>
) {
  if (!React.isValidElement(props.children)) {
    return props.children;
  }

  return React.cloneElement(props.children, {
    // @ts-ignore
    onClick: (e: React.MouseEvent) => {
      props.onClick && props.onClick(e);
      props.onTouch && props.onTouch(e);
      // @ts-ignore
      props.children && props.children.onClick && props.children.onClick(e);
    },
  });
}

Touchable.Highlight = TouchableHighlight;
Touchable.Opacity = TouchableOpacity;
Touchable.Scale = TouchableScale;
